import Title from "components/atoms/Title";

import ServiceFeeCalculator from "./ServiceFeeCalculator";

const AccountingAuditing = ({ services }) => {
  // ******
  return (
    <div className="container">
      <div className="row justify-center">
        <div className="col-12 mb-6 lg:col-10 lg:mb-10">
          <Title
            text="Accounting Service"
            className="title-h2 mb-6 text-center text-3xl font-semibold text-bbc-brand-700 lg:mb-10"
          />
          <p className="mb-0 leading-bbc-26">
            The fee for our accounting service will mainly depend on the number
            of your company’s monthly transactions:
          </p>
        </div>
        <div className="col-12 lg:col-10">
          <ServiceFeeCalculator services={services} />
        </div>
      </div>
    </div>
  );
};

export default AccountingAuditing;
